export default __webpack_public_path__ + "static/media/5323.73044216.png";